import { render, staticRenderFns } from "./LawFirm.vue?vue&type=template&id=3f5d167e&"
import script from "./LawFirm.vue?vue&type=script&lang=js&"
export * from "./LawFirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports